import { useEffect } from "react";
import axiosInstance from "../axiosInstance";
import { API_URL } from "../config";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

export default function ProfileCheckRedirect() {
    const navigate = useNavigate();

    const isProfileComplete = (profile) => {
        const fields = [
            profile.first_name,
            profile.last_name,
            profile.mobile,
            profile.qualification,
            profile.city,
            profile.state,
            profile.country,
            profile.designation,
            profile.experience,
            profile.description,
            profile.cv_path
        ];

        return fields.every((f) => f && f !== "");
    };

    useEffect(() => {
        const interval = setInterval(async () => {
            const token = localStorage.getItem("authToken");
            const role = localStorage.getItem("role");

            if (!token || role !== "candidate") return;

            try {
                const res = await axiosInstance.get(`${API_URL}/candidate-profile`);
                const profile = res.data.data;

                if (profile.status === "inactive") {
                    toast.warning("Your account is inactive. Please contact admin.");

                    localStorage.clear();
                    navigate("/login");
                    return; // stop further checks
                }

                if (!isProfileComplete(profile)) {
                    toast.warning("Please complete your profile.");

                    if (window.location.pathname !== "/candidate/profile") {
                        navigate("/candidate/profile");
                    }
                }
            } catch (err) {
                console.error("Profile check error:", err);
            }
            // }, 1800000); // 30 minute
        }, 60000); // 1 minute

        return () => clearInterval(interval);
    }, [navigate]);

    return null;
}
